(() => {
  const excluded = () => !/\/(collections\/[^/]+|search)\/?$/.test(location.pathname) || /\/collections\/new-in(?:-85)?\/?$/.test(location.pathname);
  if (window.yrpStockFirstBound || excluded()) return;
  window.yrpStockFirstBound = true;
  const states = new WeakMap();
  const gridOf = root => root.querySelector('ul#product-grid, #product-grid > ul.product-grid');
  const cardsOf = grid => grid ? [...grid.children].filter(node => node.matches('li[data-stock-item-id]')) : [];
  const signature = grid => cardsOf(grid).map(card => card.dataset.stockItemId).join(',');
  async function mapLimit(items, callback) {
    const results = new Array(items.length);
    let cursor = 0;
    await Promise.all(Array.from({length: Math.min(3, items.length)}, async () => {
      while (cursor < items.length) {
        const index = cursor++;
        results[index] = await callback(items[index]);
      }
    }));
    return results;
  }
  async function sortContainer(container) {
    if (excluded()) return;
    const grid = gridOf(container);
    if (!grid) return;
    const originalUrl = location.href;
    const initialSignature = signature(grid);
    const previous = states.get(grid);
    if (previous?.url === originalUrl && previous.signature === initialSignature) return;
    const state = {url: originalUrl, signature: initialSignature};
    states.set(grid, state);
    const base = new URL(originalUrl);
    const pageSize = Number(container.dataset.stockPageSize);
    const currentPage = Math.max(1, Number(base.searchParams.get('page')) || 1);
    if (!pageSize) return;
    async function request(section, page) {
      const url = new URL(base);
      url.searchParams.delete('sections');
      url.searchParams.set('page', String(page));
      url.searchParams.set('section_id', section);
      for (let attempt = 0; attempt < 2; attempt++) {
        try {
          const response = await fetch(url, {credentials: 'same-origin'});
          if (!response.ok) throw new Error('Product list request failed');
          return new DOMParser().parseFromString(await response.text(), 'text/html');
        } catch (error) {
          if (attempt === 1) throw error;
        }
      }
    }
    async function indexPage(page) {
      const doc = await request('yrp-stock-index', page);
      const data = doc.querySelector('[data-stock-index]');
      if (!data) throw new Error('Availability index missing');
      return JSON.parse(data.textContent);
    }
    container.setAttribute('aria-busy', 'true');
    try {
      const first = await indexPage(1);
      const rest = await mapLimit(Array.from({length: Math.max(0, first.pages - 1)}, (_, i) => i + 2), indexPage);
      const items = [first, ...rest].flatMap(page => page.items);
      if (items.length !== first.total) throw new Error('Incomplete availability index');
      const isAllProducts = /\/collections\/all\/?$/.test(base.pathname);
      const indexed = items.map((item, index) => ({...item, index}));
      const ranked = isAllProducts ? indexed.filter(item => item.id !== '7031319888067') : indexed;
      if (isAllProducts && ranked.length !== items.length) {
        const pages = Math.max(1, Math.ceil(ranked.length / pageSize));
        if (currentPage > pages) {
          base.searchParams.set('page', String(pages));
          location.replace(base.toString());
          return;
        }
        const count = document.querySelector('.yrp-collection-header__count');
        if (count) count.textContent = count.textContent.replace(/[\d.,'’]+/, new Intl.NumberFormat(document.documentElement.lang || 'de-CH').format(ranked.length));
        container.dataset.stockTotal = String(ranked.length);
        grid.dataset.totalPages = String(pages);
      }
      const sortBy = base.searchParams.get('sort_by');
      const mixAllProducts = /\/collections\/all\/?$/.test(base.pathname) && (!sortBy || sortBy.startsWith('title-'));
      const mixedRank = id => {
        let hash = 2166136261;
        for (const char of id) hash = Math.imul(hash ^ char.charCodeAt(0), 16777619);
        hash = Math.imul(hash ^ (hash >>> 16), 2246822507);
        hash = Math.imul(hash ^ (hash >>> 13), 3266489909);
        return (hash ^ (hash >>> 16)) >>> 0;
      };
      if (mixAllProducts) for (const item of ranked) item.mixedRank = mixedRank(item.id);
      ranked.sort((a, b) => (a.available === true ? 0 : 1) - (b.available === true ? 0 : 1) || (mixAllProducts ? a.mixedRank - b.mixedRank : 0) || a.index - b.index);
      const wanted = ranked.slice((currentPage - 1) * pageSize, currentPage * pageSize);
      const cards = new Map(cardsOf(grid).map(card => [card.dataset.stockItemId, card]));
      const pages = [...new Set(wanted.filter(item => !cards.has(item.id)).map(item => Math.floor(item.index / pageSize) + 1))];
      await mapLimit(pages, async page => {
        const doc = await request(container.dataset.stockFirstSection, page);
        const source = doc.querySelector('[data-stock-first-section]');
        if (!source) throw new Error('Product cards missing');
        for (const card of cardsOf(gridOf(source))) cards.set(card.dataset.stockItemId, card);
      });
      const ordered = wanted.map(item => cards.get(item.id));
      if (!ordered.length || ordered.some(card => !card)) throw new Error('Incomplete product cards');
      if (location.href !== originalUrl || !grid.isConnected || states.get(grid) !== state) return;
      state.signature = ordered.map(card => card.dataset.stockItemId).join(',');
      grid.replaceChildren(...ordered);
    } catch (error) {
      console.warn('Availability ordering:', error.message);
      if (states.get(grid) === state) states.delete(grid);
    } finally {
      if (states.get(grid) === state || !states.has(grid)) container.removeAttribute('aria-busy');
    }
  }
  let queued = false;
  const run = () => {
    if (!excluded()) document.querySelectorAll('[data-stock-first-section]').forEach(sortContainer);
  };
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    queueMicrotask(() => { queued = false; run(); });
  }).observe(document.getElementById('MainContent') || document.body, {childList: true, subtree: true});
  window.addEventListener('popstate', run);
  run();
})();
